/* eslint-disable zeffy-linter-frontend/no-classname-prop -- legacy baseline (pre-rule); remove when these are migrated */
import { FC } from "react";

import { FormType } from "@simplyk/common";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { parseAddress } from "@/canvas/features/FormV2/helpers/parseAddress";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormIcon } from "@/forms-design-system/FormIcon";
import { FormInfobox } from "@/forms-design-system/FormInfobox/FormInfobox";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { Location } from "@/icons/outlined";

export const PickupAddressInfobox: FC = () => {
  const { t } = useTranslate();
  const { formObject } = useFormV2Context(FormType.Ticketing);

  const parsedAddress = formObject.address ? parseAddress(formObject.address) : undefined;
  const addressLine = parsedAddress
    ? [parsedAddress.street, parsedAddress.cityStateZip].filter(Boolean).join(", ")
    : formObject.address?.trim();

  if (!addressLine) {
    return null;
  }

  return (
    <FormInfobox
      icon={
        <FormIcon size="medium">
          <Location className="svg-safari-fix" />
        </FormIcon>
      }
      title={t("ticketing", "fulfillment.pickupAddressLabel")}
      description={
        <FormTypography variant="body2" vibe="moderate">
          {addressLine}
        </FormTypography>
      }
      data-test="fulfillment-pickup-address"
    />
  );
};
